function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import style from './Footer.module.css';
import { IsViewport } from '@zambezi/layout-grid';
var isExternalLink = function isExternalLink(link) {
  return link.indexOf('http') === 0;
};
var formatFooterItem = function formatFooterItem(str) {
  return str.replace(/[^A-Z0-9]+/gi, '-').toLowerCase();
};
var Footer = function Footer(_ref) {
  var brand = _ref.brand,
    excludeLinks = _ref.excludeLinks,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'zb-flex-none' : _ref$className,
    _ref$basePath = _ref.basePath,
    basePath = _ref$basePath === void 0 ? '' : _ref$basePath,
    _ref$forceLinksInNewT = _ref.forceLinksInNewTab,
    forceLinksInNewTab = _ref$forceLinksInNewT === void 0 ? false : _ref$forceLinksInNewT,
    oldStyle = _ref.oldStyle,
    isLegacyTheme = _ref.isLegacyTheme;
  return /*#__PURE__*/React.createElement("footer", {
    className: classNames('zb-footer js-footer', {
      'ob-footer-old-style': oldStyle
    }, _defineProperty({}, style.legacyBrand, isLegacyTheme), className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('zb-container', isLegacyTheme ? '' : 'zb-flex zb-flex-row')
  }, !excludeLinks && /*#__PURE__*/React.createElement(IsViewport, {
    isDesktop: true,
    isWidescreen: true
  }, brand.get('footer').map(function (link, label) {
    return /*#__PURE__*/React.createElement("span", {
      className: classNames('ob-footer-item zb-is-hidden-tablet zb-is-hidden-mobile', isLegacyTheme ? style.legacyFooterItem : 'zb-flex zb-flex-row'),
      key: label
    }, forceLinksInNewTab || isExternalLink(link) ? /*#__PURE__*/React.createElement("a", {
      href: isExternalLink(link) ? link : basePath + link,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "zb-footer-nav-item js-".concat(formatFooterItem(label))
    }, label) : /*#__PURE__*/React.createElement(Link, {
      to: link,
      className: "zb-footer-nav-item js-".concat(formatFooterItem(label))
    }, label), /*#__PURE__*/React.createElement("span", {
      className: "ob-footer-separator zb-footer-text"
    }, " | "));
  }).toArray()), /*#__PURE__*/React.createElement("span", {
    className: classNames('zb-footer-text js-copyright', style.legacyCopyright)
  }, brand.get('copyright'))));
};
export default Footer;